import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JobTemplate } from '../../../../core/models/job';
import { JobTemplateService } from '../../../../core/services/job-template.service';
import { ConfirmDeleteJobTemplateComponent } from '../../modals/jobActions/confirm-delete-job-template/confirm-delete-job-template.component';
import { UpdateJobTemplateComponent } from '../../modals/jobActions/update-job-template/update-job-template.component';
import { NavigationService } from 'src/app/core/services/navigation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/authentication.service';
import { UserRoleNames } from 'src/app/core/models/users';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-job-template-list',
  templateUrl: './job-template-list.component.html',
  styleUrls: ['./job-template-list.component.scss']
})
export class JobTemplateListComponent implements OnInit {
  jobTemplates: JobTemplate[];
  filteredTemplates: JobTemplate[] = [];
  p: number = 1;
  dataAvailable: boolean = true;
  searchTerm: string = '';
  loggedInUserRole: string = this.authenticationService.getRole() || "";
  isMonitor: boolean = this.loggedInUserRole == UserRoleNames.Reader;
  depName: string = this.route.snapshot.params["deploymentName"] || this.route.parent.snapshot.params["deploymentName"]; 

  constructor(
    private jobTemplateService: JobTemplateService, 
    private dialog: MatDialog, 
    private navService: NavigationService, 
    private router: Router,
    private authenticationService: AuthenticationService,
    private route: ActivatedRoute,
    private spinner: NgxSpinnerService,
  ) { }

  ngOnInit(): void {
    this.navService.sendParentData('Templates');
    this.navService.sendLeftPanelIndex(2);
    this.getJobTemplates();
  }

  getJobTemplates(): void {
    this.jobTemplateService.getJobTemplates(this.depName)
      .subscribe(jobTemplates => {
        this.jobTemplates = jobTemplates;
        this.filteredTemplates = jobTemplates;
      });
  }

  createJobTemplate(): void {

  }

  updateJobTemplate(jobTemplate: JobTemplate): void {
    const dialogRef = this.dialog.open(UpdateJobTemplateComponent, {
      width: "35%",
      autoFocus: true,
      disableClose: true,
      data: {
        templateName: jobTemplate.templateName,
        originalTemplateName: jobTemplate.templateName,

      }
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        jobTemplate.templateName = result.templateName;

        this.jobTemplateService.updateJobTemplate(jobTemplate)
          .subscribe(updatedJobTemplate => {
            const index = this.jobTemplates.findIndex(jt => jt.templateId === updatedJobTemplate.templateId);
            if (index !== -1) {
              this.jobTemplates[index] = updatedJobTemplate;
            }
          });
      }
    });
  }

  deleteJobTemplate(templateId: string): void {
    const dialogRef = this.dialog.open(ConfirmDeleteJobTemplateComponent, {
      width: "35%",
      autoFocus: true,
      disableClose: true
    });

    try{
      dialogRef.afterClosed().subscribe((result) => {
        if (result) {
          this.spinner.show();
          this.jobTemplateService.deleteJobTemplate(templateId)
            .subscribe({
              next: () => {
                this.jobTemplates = this.jobTemplates.filter(jt => jt.templateId !== templateId);
                this.refreshComponent();
                this.spinner.hide();
              },
              error: (error) => {
                this.spinner.hide();
                console.error('Error deleting job template:', error);
              },
            });
        }
      });
    }
    catch (error) {
      this.spinner.hide();
      console.error('Error deleting job template:', error);
    }
  }

  onSearchChange(): void {
    if (this.searchTerm) {
      this.filteredTemplates = this.jobTemplates.filter(template =>
        template.templateName.toLowerCase().includes(this.searchTerm.toLowerCase())
      );
    } else {
      this.filteredTemplates = this.jobTemplates;
    }
  }
  refreshComponent() {
    let url = this.router.url;
    this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
      this.router.navigate([decodeURI(url)]);
    });
  }
}
